import React from 'react';
import { motion } from 'framer-motion';
const promises = [{
  icon: '🧠',
  title: 'Entiende su cerebro',
  description: 'Neurociencia del desarrollo explicada en lenguaje humano. Entender es la primera forma de conectar.'
}, {
  icon: '💬',
  title: 'Habla con él/ella',
  description: 'Frases concretas, momentos ideales y estrategias para abrir puertas que parecen selladas.'
}, {
  icon: '🏠',
  title: 'Crea un hogar seguro',
  description: 'Límites con amor, rutinas que conectan y espacios donde tu hijo quiera volver a abrirse.'
}, {
  icon: '💪',
  title: 'Sé constante',
  description: 'Estrategias para los días difíciles. Herramientas para cuidarte a ti mientras cuidas a tu familia.'
}];
export function PromiseSection() {
  return <section className="bg-[#1A2744] text-white py-20 px-5 text-center" data-id="element-251">
      <div className="max-w-5xl mx-auto" data-id="element-252">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-253">
          <div className="inline-block text-xs font-bold tracking-[3px] uppercase text-[#F4A535] mb-4" data-id="element-254">
            La buena noticia
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl mb-5 leading-tight" data-id="element-255">
            La adolescencia no es el problema.
            <br data-id="element-256" />
            <span className="text-[#F4A535]" data-id="element-257">Es la solución.</span>
          </h2>

          <p className="text-lg text-[#B8C8E8] max-w-2xl mx-auto mb-16" data-id="element-258">
            Todo lo que parece caótico tiene un propósito evolutivo preciso. Y
            tú puedes aprender a acompañarlo sin miedo, sin gritos, sin perder
            la conexión.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-4xl mx-auto" data-id="element-259">
          {promises.map((promise, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="text-center" data-id="element-260">
              <div className="w-[70px] h-[70px] bg-[rgba(244,165,53,0.15)] border-2 border-[rgba(244,165,53,0.3)] rounded-full flex items-center justify-center text-3xl mx-auto mb-4" data-id="element-261">
                {promise.icon}
              </div>
              <h3 className="text-base font-bold text-[#F4A535] mb-2" data-id="element-262">
                {promise.title}
              </h3>
              <p className="text-sm text-[#8AA0C0]" data-id="element-263">{promise.description}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}